/**
 * Broadcast-related constants and configuration
 */

// Available sports for broadcasts
export const SPORTS_LIST = [
  "Football", 
  "Basketball", 
  "Boys Basketball", 
  "Girls Basketball", 
  "Mens Basketball", 
  "Womens Basketball", 
  "Soccer", 
  "Baseball", 
  "Softball", 
  "Volleyball", 
  "Wrestling", 
  "Tennis", 
  "Golf", 
  "Track & Field", 
  "Swimming", 
  "Lacrosse", 
  "Hockey"
];

// Default form data for new broadcasts
export const DEFAULT_BROADCAST_FORM = {
  title: "", 
  sport: "Football", 
  channel_id: "", 
  scheduled_date: "", 
  scheduled_time: "", 
  description: "",
  location: "",
  location_image: "",
  ticket_link: "",
  date_tbd: false,
  time_tbd: false,
  home_team: { name: "", abbreviation: "", mascot: "", color: "#1a1a1a", logo_url: "" },
  away_team: { name: "", abbreviation: "", mascot: "", color: "#003087", logo_url: "" },
  external_links: [],
  stats_link: "",
  stats_provider: "prestosports",
  show_stats_overlay: true,
  event_id: "",
  youtube_url: "",
  thumbnail_url: "",
  end_time: ""
};

// Default past game form data
export const DEFAULT_PAST_GAME_FORM = {
  sport: "Football",
  game_date: "",
  video_url: "",
  youtube_url: "",
  thumbnail_url: "",
  stats_link: "",
  event_id: "",
  home_team: { name: "", abbreviation: "", mascot: "", color: "#1a1a1a", logo_url: "" },
  away_team: { name: "", abbreviation: "", mascot: "", color: "#003087", logo_url: "" },
  final_home_score: "",
  final_away_score: "",
  publish_immediately: true
};

// Stats providers
export const STATS_PROVIDERS = [
  { id: "prestosports", name: "PrestoSports (Default)", hasOverlay: true },
  { id: "statmoose", name: "StatMoose", hasOverlay: true },
  { id: "ncaa", name: "NCAA Stats", hasOverlay: false },
  { id: "custom", name: "Custom URL", hasOverlay: false }
];

// External link types
export const LINK_TYPES = [
  { id: "stats", label: "Stats" },
  { id: "roster", label: "Roster" },
  { id: "tickets", label: "Tickets" },
  { id: "social", label: "Social Media" },
  { id: "other", label: "Other" }
];
